import React, { FC } from 'react'
import { Box } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui'
import { Calendar, ICalendarProps } from '../Calendar'

export interface ICalendarFormInputProps extends ICalendarProps {
  label?: string
  /**
   * @default false
   */
  required?: boolean
  /**
   * @default false
   */
  fullWidth?: boolean
}

export const CalendarFormInput: FC<ICalendarFormInputProps> = ({
  disabled,
  fullWidth = false,
  label,
  maxDate,
  minDate,
  onChange,
  required = false,
  value,
}) => {
  const display = fullWidth ? 'flex' : 'inline-flex'

  return (
    <Box data-test='calendar-form-input'>
      {label && (
        <legend
          data-test='calendar-form-input'
          className={`${required ? 'required' : ''} label pb1`}>
          {label}
        </legend>
      )}
      <Box
        border={1}
        borderRadius='4px'
        borderColor={`${disabled ? brandColors.coolGray4 : brandColors.coolGray5}`}
        justifyContent='center'
        display={display}>
        <Calendar
          value={value}
          onChange={onChange}
          minDate={minDate}
          maxDate={maxDate}
          disablePast={disabled}
          disableFuture={disabled}
          disabled={disabled}
        />
      </Box>
    </Box>
  )
}

export default CalendarFormInput
